import { render, staticRenderFns } from "./communicationDashboardPopupsNew.vue?vue&type=template&id=dbac39e8&scoped=true"
import script from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPopupsNew.vue?vue&type=style&index=0&id=dbac39e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbac39e8",
  null
  
)

export default component.exports